export default __webpack_public_path__ + "static/media/IFSEC_India_Logo-1.50a83888.jpg";